import FormFieldLabel from './FormFieldLabel';

export default FormFieldLabel;
